import React from 'react'

import { BossProvider } from '../../../context'
import CustomBasePage from '../../../CustomBasePage'
import VideoAdsList from './List'

const VideoAdsPage: React.FC<React.PropsWithChildren<unknown>> = () => (
  <BossProvider>
    <CustomBasePage>
      <VideoAdsList marginY={2} />
    </CustomBasePage>
  </BossProvider>
)

export default VideoAdsPage
